// extracted by mini-css-extract-plugin
export default {"ChooseUsernameContainer":"ChoosUsername_ChooseUsernameContainer__WuxWq","dashboardlink":"ChoosUsername_dashboardlink__NtyrD"};